import React from 'react';

const KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';

const VCCtaSection = () => (
    <section className="lp-cta">
        <div className="lp-cta-card" data-lp-reveal>
            <div className="lp-cta-glow" aria-hidden="true" />
            <div className="lp-cta-inner">
                <h2>Ready to get started?</h2>
                <p className="sub">Book a 30-minute call to see the 360-degree triage dashboard and model the portfolio value impact for your fund.</p>
                <a className="lp-cta-btn" href={KOALENDAR} target="_blank" rel="noopener noreferrer">
                    <span className="av"><img src={require('../../../../images/landing-pages/PE/book-a-call-mark.png')} alt="Mark Bernstein" /></span>
                    Book a call
                </a>
            </div>
        </div>
    </section>
);

export default VCCtaSection;
